import type { CrashlyticsPort, CrashStackFrame } from "./crashlyticsPorts.js";

/** Safe no-op crash reporting implementation for unsupported runtimes and fallback paths. */
export class NoopCrashlyticsAdapter implements CrashlyticsPort {
  isAvailable(): boolean {
    return false;
  }

  recordException(_message: string, _opts?: { stacktrace?: CrashStackFrame[] }): void {
    /* no-op */
  }

  log(_message: string): void {
    /* no-op */
  }

  setUserId(_userId: string): void {
    /* no-op */
  }

  setCustomKey(_key: string, _value: string | number | boolean): void {
    /* no-op */
  }

  setEnabled(_enabled: boolean): void {
    /* no-op */
  }
}
